import {
  SettingParamTypes,
  WorkflowNodeData,
  WorkflowNodeTypes,
} from "@/types/node";
import {Node} from "@xyflow/react";

export const instructionNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.INSTRUCTION,
  position: {x: 0, y: 0},
  measured: {height: 115, width: 340},
  data: {
    type: WorkflowNodeTypes.INSTRUCTION,
    settingsTitle: "Instruction",
    nodeTitle: "Instruction",
    description: "This is the instruction node",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "General",
        expandedSetting: true,
        params: [
          {
            label: "Instruction Name",
            placeholder: "Enter Instruction Name",
            type: SettingParamTypes.INPUT,
            key: "name",
            value: "",
          },
          {
            label: "Instructions",
            placeholder:
              "Add instructions on how the AI Assistant should behave during this instruction.",
            type: SettingParamTypes.PROMPT,
            key: "instructions",
            value: "",
          },
        ],
      },
      {
        title: "Actions",
        icon: "Zap",
        params: [
          {
            label: "Actions",
            type: SettingParamTypes.ACTIONS,
            key: "actions",
            value: [],
          },
        ],
      },
      {
        title: "Collect Variables",
        icon: "Braces",
        params: [
          {
            type: SettingParamTypes.CAPTURE,
            key: "variables",
            unitName: "Variable",
            value: [],
            settingName: "Variables",
          },
        ],
      },
    ],
  },
};
